import { Box, IconButton, Skeleton, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { ArrowBack, Business } from '@mui/icons-material'
import { MIN_BUTTON_SIZE } from '../constants'

interface PageTitleWithLinkedServiceProps {
  pageTitle: string
  linkedServiceName?: string
  moduleName: string
  handleBackClick: () => void
  className?: string
  isLoading?: boolean
}

export default function PageTitleWithLinkedService({
  pageTitle,
  linkedServiceName,
  moduleName,
  handleBackClick,
  className,
  isLoading = false,
}: PageTitleWithLinkedServiceProps): ReactElement {
  return (
    <Box className={className || ''}>
      {isLoading ? (
        <>
          <Box className="mb-2">
            <Skeleton variant="text" width={200} height={20} />
          </Box>
          <Box className="flex items-center gap-2">
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="text" width={300} height={60} />
          </Box>
        </>
      ) : (
        <>
          <Box className="mb-2">
            <Typography
              variant="body2"
              component="h6"
              color="text.secondary"
              className="flex items-center gap-2"
            >
              <Business fontSize="small" aria-hidden="true" />
              {linkedServiceName}
            </Typography>
          </Box>
          <Box className="flex items-center gap-2">
            <IconButton
              onClick={handleBackClick}
              aria-label={`Go back to ${moduleName}`}
              sx={{ minWidth: MIN_BUTTON_SIZE, minHeight: MIN_BUTTON_SIZE }}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" component="h1">
              {pageTitle}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  )
}
